import styled from '@emotion/styled';
import BackgroundImage from 'gatsby-background-image';
import Img from 'gatsby-image';
import React from 'react';

import { H3, theme } from '@kindur/components';

import { Link } from 'gatsby';
import withTracking from '../../components/Common/withTracking';
import { BasicLinkButton } from '../../elements/LinkButton';

const Container = styled('div')`
  text-align: left;
  ${theme.breakpoints.smallTabletDown} {
    height: auto;
  }
`;
const Padding = styled('div')`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 6rem 24px;
  margin: 0 auto;
  max-width: 1158px;
  ${theme.breakpoints.tabletDown} {
    flex-flow: column nowrap;
    padding: 24px;
  }
`;
const TextContainer = styled('div')`
  max-width: 333px;
  ${theme.breakpoints.tabletDown} {
    max-width: unset;
  }
`;
const Title = styled(H3)`
  font-family: 'Apercu Pro Bold', sans-serif;
  font-size: 24px;
  letter-spacing: 0.25px;
  line-height: 32px;
  margin: 0 auto 16px auto;
  ${theme.breakpoints.tabletDown} {
    margin-bottom: 12px;
    text-align: left;
  }
`;
const Copy = styled('div')`
  font-size: 18px;
  letter-spacing: 0.2px;
  line-height: 30px;
  margin-bottom: 24px;
`;
const CTALink = styled(Link)`
  background: transparent;
  color: #0aae96;
  font-family: 'Apercu Pro Bold', sans-serif;
  font-size: 18px;
  letter-spacing: 0.09px;
  line-height: 30px;
  text-decoration: none;
  white-space: nowrap;
  ${theme.breakpoints.tabletDown} {
  }
`;
const BulletsContainer = styled('div')`
  max-width: 333px;
  ${theme.breakpoints.tabletDown} {
    max-width: unset;
  }
`;
const BulletPoint = styled('div')`
  border-top: 1px solid #0b4b40;
  font-family: 'Apercu Pro Regular', sans-serif;
  font-size: 18px;
  letter-spacing: 0.23px;
  line-height: 30px;
  padding: 12px 0;
  :before {
    content: '✓ ';
  }
  ${theme.breakpoints.tabletDown} {
  }
`;
const Image = styled(Img)`
  margin-top: 40px;
  width: 360px;
  ${theme.breakpoints.tabletDown} {
    width: 100%;
  }
`;

const TrackComponentName = `SmartDraw`;

const SmartDraw = ({ content, image, track }) => {
  return (
    <React.Fragment>
      <Container>
        <Padding>
          <TextContainer>
            <Title>{content.title}</Title>
            <Copy>{content.copy}</Copy>
          </TextContainer>
          <BulletsContainer>
            {content.bullets.map((text, i) => (
              <BulletPoint key={`bullet-${i}`}>{text}</BulletPoint>
            ))}
          </BulletsContainer>
          <Image fluid={image} alt={``} />
        </Padding>
      </Container>
    </React.Fragment>
  );
};

SmartDraw.displayName = TrackComponentName;

export default withTracking(SmartDraw);
